<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="meetings-stack">
    <div class="title-block">
      <div class="left">
        <span class="title light">{{ 'library.meetings-stack.title' | customLocale }}</span>
        <span class="text normal">{{ 'library.meetings-stack.text' | customLocale }}</span>
      </div>
      <div class="right">
        <on-ui-button class="primary outline"
                      [attr.data-test] = "'meetings_stack_schedule_button'"
                      label="library.meetings-stack.action"
                      *ngIf="!isGuest && isTeacher"
                      (onclick)="goScheduleClass()">
        </on-ui-button>
      </div>
    </div>
    <hr class="separator">

    <div class="group-block">
      <div *ngFor="let group of groupsMeetings; trackBy: trackByGroupMeetingsFn" class="group-item">
        <h2 class="group-title">{{ group?.title | customLocale }}</h2>
        <app-meetings-group [meetings]="group?.list"></app-meetings-group>
      </div>
    </div>
  </div>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && meetingForm"
           [canClose]="false"
           (closed)="onToggleMeetingForm()">
  <app-modal-body>
    <app-meeting-form
      class="meting-form-modal"
      [meeting]="newMeeting"
      [references]="references"
      [creditsAmount]="creditsAmount"
      [cover]="cover"
      (buyCredits)="onBuyCredits()"
      (openGallery)="onOpenGallery()"
      (saved)="onMeetingSaved($event)">
    </app-meeting-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && meetingForm"
                  [titleVisible]="false">
  <app-mobile-modal-body>
    <div class="modal-header">
      <h2 class="modal-title bold">{{ 'meetings.form-title' | customLocale }}</h2>
      <div class="close-btn" (click)="onToggleMeetingForm()">
        <app-icon width="20" height="20" icon="close"></app-icon>
      </div>
    </div>
    <app-meeting-form
      [meeting]="newMeeting"
      [references]="references"
      [creditsAmount]="creditsAmount"
      [cover]="cover"
      (buyCredits)="onBuyCredits()"
      (openGallery)="onOpenGallery()"
      (saved)="onMeetingSaved($event)">
    </app-meeting-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<!-- Gallery -->
<app-media-file-selector
  *ngIf="openGallery"
  type="image"
  [purpose]="filePurpose"
  (changed)="setCover($event)"
  (closed)="closeGallery()"
></app-media-file-selector>
